import React from 'react';
import { Select } from './Select';

export const FormSelect = ({
  label,
  name,
  value,
  onChange,
  options,
  error,
  required = false,
  disabled = false,
  placeholder,
  ...props
}) => {
  const handleValueChange = (newValue) => {
    // Simulate native event structure for compatibility
    onChange({
      target: { name, value: newValue }
    });
  };

  return (
    <div>
      {label && (
        <label className="form-label">
          {label} {required && '*'}
        </label>
      )}
      <Select
        value={value}
        onValueChange={handleValueChange}
        options={options}
        error={!!error}
        disabled={disabled}
        placeholder={placeholder}
        {...props}
      />
      {error && (
        <p className="text-red-500 text-sm mt-1">{error}</p>
      )}
    </div>
  );
};
